<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <router-link to="/email">
          <a>返回邮件列表</a>
        </router-link>

        <cite>|</cite>
        <span style="font-size: 12px;color: red">
          提示：程序开始发送后，会下载邮件到本地，所以修改邮件内容不会生效。若需修改邮件内容，需要新建邮件->重新分配发送
        </span>

      </div>
    </Card>

    <!--<Card  :bordered="false" dis-hover style="margin-bottom:10px;">-->
      <!--邮件类型：-->
      <!--<RadioGroup v-model="type">-->
        <!--<Radio label="普通邮件"></Radio>-->
        <!--<Radio label="变量邮件" :disabled="true"></Radio>-->
      <!--</RadioGroup>-->
    <!--</Card>-->

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" >
      <p slot="title"><font color="red">*</font> 邮件名称（仅方便区分，并非邮件标题）</p>
      <Input placeholder="输入邮件名称" v-model="form.name"></Input>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-if="type=='变量邮件'" >
      主题变量：
      <Select style="width:280px" v-model="mid">
        <Option v-for="item in cplist" :value="item.id">{{item.name}}<cite>/</cite>{{item.count}}</Option>
      </Select>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-if="type=='变量邮件'" >
      <Upload
        multiple
        type="drag"
        action="/api/upload/upload"
        :on-success="upload"
        :on-remove="uploadRemove"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p class="font-fuzhu">点击或拖拽上传，支持批量上传</p>
        </div>
      </Upload>

      <table class="layui-table">
        <thead>
        <tr>
          <th style="width:450px">附件名称</th>
          <th>选择变量</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in uploadlist">
          <td><Input v-model="item.name" readonly=""></Input></td>
          <td>
            <Select style="width:280px" v-model="item.mid">
              <Option v-for="item in cplist" :value="item.id">{{item.name}}<cite>/</cite>{{item.count}}</Option>
            </Select>
          </td>
        </tr>
        </tbody>
      </table>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-if="type=='普通邮件'">
      <p slot="title"><font color="red">*</font> 邮件标题</p>
      <Input placeholder="输入邮件标题" v-model="form.title"></Input>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <p slot="title"><font color="red">*</font> 邮件内容<cite>|</cite>
        <font color="red">
          邮件内容和标题不能包含英文单引号，若有单引号系统会自动改为英文双引号
        </font>
      </p>
      <Input type="textarea" v-model="form.content" :autosize="{minRows: 12,maxRows: 12}" placeholder="输入html代码"></Input>
      <!--<br/>-->
      <!--<br/>-->
      <!--<span class="lan">E0312_CURRENT_EMAIL</span><cite>-</cite>替换当前收件箱（包含@后面部分）<br/>-->
      <!--<span class="lan">E0313_CURRENT_EMAILUSER</span><cite>-</cite>替换当前收件箱（不包含@后面部分）<br/>-->
      <!--<span class="lan">E0314_UUID</span><cite>-</cite>生成32位随机英文+数字字符<br/>-->
      <!--<span class="lan">E0315_RANDOM_STR</span><cite>-</cite>生成1-20个随机汉字<br/>-->
      <!--&lt;!&ndash;<span class="lan">%EBP_1_EBP%</span><cite>-</cite>替换随机变量 1 表示 变量的ID&ndash;&gt;-->

    <!--</Card>-->

    <!--<Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-if="type=='普通邮件'">-->
      <!--<div slot="title">附件上传-->
      <!--</div>-->
      <!--<Alert v-if="fids.length>0"> &nbsp;已选择{{fids.length}}个附件，<a @click="fids=[]">点击清空</a></Alert>-->
      <!--<Upload-->
        <!--:on-success="uploadSuccess"-->
        <!--type="drag"-->
        <!--multiple="true"-->
        <!--action="/api/upload/upload">-->
        <!--<div style="padding: 20px 0">-->
          <!--<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>-->
          <!--<p>点击选择或拖拽到此处上传，支持多附件上传</p>-->
        <!--</div>-->
      <!--</Upload>-->
    </Card>

    <!--<Card  :bordered="false" dis-hover style="margin-bottom:10px;" >-->
      <!--<p slot="title">指定回复邮箱</p>-->
      <!--<Input placeholder="输入指定回复邮箱" v-model="form.zhiding"></Input>-->
    <!--</Card>-->

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <Button type="primary" @click="save" v-if="type=='普通邮件'">保存普通邮件</Button>
      <Button type="primary" @click="savecp" v-if="type=='变量邮件'">保存变量邮件</Button>
    </Card>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        fids:[],
        type:'普通邮件',
        form:{
          id:0,
          title:'',
          content:'',
          zhiding:'',
        },
        cplist:[],
        mid:0,
        uploadlist:[],//变量附件上传
      }
    },
    methods:{
      save(){
        let that = this;
        this.$axios({url:'/api/email/save?fids='+this.fids,method:'post',data:this.$qs.stringify(this.form)}).then(function(rs){
          that.toast(rs.data);
        });
      },
      toast(data){
        if(data.success){
          this.$Message.success(data.msg);
          this.$router.push({path:'/email'});
        }else{
          this.$Message.error(data.msg);
        }
      },
      uploadSuccess(response, file, fileList){
        this.fids.push(response.upload.id);
      },
      //变量邮件上传
      upload(response, file, fileList){
        this.uploadlist.push({fid:response.upload.id,name:response.upload.name});
      },
      uploadRemove(file, fileList){
        let id = file.response.upload.id;
        for(let i = 0;i<this.uploadlist.length;i++){
          if(id===this.uploadlist[i].fid){
            this.uploadlist.splice(i,1);
          }
        }
        this.fid.splice(this.fid.lastIndexOf(id),1);
      },

      loadcp(){
        let that = this;
        this.$axios.get('/api/cp/cpgroup/findall?page=1&limit=1000').then(function(rs){
          that.cplist = rs.data.data;
        });
      },
      savecp(){
        let cpform = {
          mid:this.mid,
          fids:'',
          mids:'',
        };
        for(let i = 0;i<this.uploadlist.length;i++){
          if(i>=1){
            cpform.fids+=',';
            cpform.mids+=',';
          }
          cpform.fids += this.uploadlist[i].fid;
          cpform.mids += this.uploadlist[i].mid;
        }
        let that = this;
        this.$axios({url:'/api/email/savecp?fids='+cpform.fids+'&mids='+cpform.mids+'&mid='+cpform.mid,method:'post',data:this.$qs.stringify(this.form)}).then(function(rs){
           that.toast(rs.data);
        });
      }

    },
    created(){
      this.loadcp();
      let id = this.$router.history.current.query.id;
      if(id>0){//加载数据
        let that = this;
        this.$axios.get('/api/email/getById?id='+id).then(function(rs){
          that.form = rs.data;
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/email/EmailEdit.vue